module.exports = __webpack_public_path__ + "static/media/james.d81a381d.jpg";